import React, {Component} from 'react'
import Elm from 'react-elm-components'
import config from '../../../lib/config'
import MyElmComponent from '../../../elm/src/ShowDocumentsPage.elm'
import {connect} from 'react-redux'
import icons from '../../core/components/Icon.less'

class ShowDocumentsPage extends Component {
    computeCriterias() {
        const {router} = this.props
        const {ticket} = this.props.ticket
        const {company, agency} = this.props.company

        if (router.location.pathname.match(/tickets/) && ticket) {
            const {linkedEntities} = ticket
            const {openedFromSimplifiedRequest} = linkedEntities

            return {
                simplifiedRequestUid: openedFromSimplifiedRequest || null,
                entityUid: ticket.uid,
                entityType: 'Ticket',
            }
        }
        if (router.location.pathname.match(/agencies/) && agency && agency.agency) {
            return {
                entityUid: agency.agency.uid,
                entityType: 'Agency',
            }
        }
        if ((router.location.pathname.match(/companies/) || router.location.pathname.match(/organisations/)) && company) {
            return {
                entityUid: company.uid,
                entityType: 'ClientCompany',
            }
        }

        return null
    }

    render() {
        const criterias = this.computeCriterias()
        if (!criterias) {
            return null
        }

        const flags = {
            ...{
                simplifiedRequestUid: null,
            }, ...criterias, ...{
                queryApiBaseUrl: config.api.url,
                icons: Object.entries(icons),
            },
        }

        return (
            <div><Elm src={MyElmComponent.Elm.ShowDocumentsPage} flags={flags}/></div>
        )
    }
}


export default connect(({ticket, company, router}) => ({ticket, company, router}))(ShowDocumentsPage)


// WEBPACK FOOTER //
// ./lib/ticket/components/ShowDocumentsPage.js